import React from "react"

function Relationship({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.22 28.228C21.22 28.228 22.0635 25.9788 22.3129 25.315C22.3541 25.2051 22.4588 25.1326 22.5761 25.1326C23.2832 25.1326 25.7153 25.1326 26.5472 25.1326C26.7021 25.1326 26.8283 25.0069 26.8283 24.8515C26.8283 23.9509 26.8283 21.1557 26.8283 20.4597C26.8283 20.3614 26.8796 20.2705 26.9636 20.2192C27.2147 20.067 27.7617 19.7352 28.1485 19.5005C28.3922 19.3525 28.4868 19.046 28.3689 18.7865C27.9435 17.8521 26.9943 15.7667 26.7908 15.3196C26.7655 15.2631 26.7491 15.2028 26.7433 15.141C26.7242 14.947 26.6788 14.4804 26.6349 14.0258C26.5297 12.9446 26.1714 11.9034 25.588 10.9865C24.8164 9.77413 23.7102 8.75572 21.9969 8.0893C20.2983 7.6533 18.6483 7.68448 17.0375 8.0893C13.9352 8.92644 12.3175 11.2935 11.742 14.0369"
        stroke="#003E4C"
        strokeWidth="0.995914"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.78 28.2266C14.78 28.2266 13.9365 25.9773 13.6871 25.3136C13.6459 25.2036 13.5412 25.1312 13.4239 25.1312C12.7168 25.1312 10.2847 25.1312 9.45282 25.1312C9.29795 25.1312 9.17166 25.0054 9.17166 24.8501C9.17166 23.9495 9.17166 21.1543 9.17166 20.4583C9.17166 20.36 9.1204 20.2691 9.03637 20.2178C8.78533 20.0656 8.23833 19.7337 7.85149 19.4991C7.60783 19.3511 7.51325 19.0446 7.63112 18.7851C8.05655 17.8507 9.00571 15.7653 9.20918 15.3182C9.23455 15.2616 9.25093 15.2014 9.25673 15.1395C9.27576 14.9456 9.32122 14.4789 9.36508 14.0244C9.47026 12.9431 9.82859 11.902 10.412 10.9851C11.1836 9.77271 12.2898 8.7543 14.0031 8.08788C15.7017 7.65187 17.3517 7.68306 18.9625 8.08788C22.0648 8.92501 23.6825 11.2921 24.258 14.0355"
        stroke="#003E4C"
        strokeWidth="0.995914"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1204 11.8418C14.3119 16.7825 13.1636 20.4082 18.1204 21.568"
        stroke="#003E4C"
        strokeWidth="1.00341"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1208 11.8393C21.9292 16.7799 23.0776 20.4057 18.1208 21.5654"
        stroke="#003E4C"
        strokeWidth="1.00341"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1084 24.1579V11.8413"
        stroke="#003E4C"
        strokeWidth="0.82468"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0973 19.8531L15.1119 16.8677"
        stroke="#003E4C"
        strokeWidth="1.00341"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1215 16.8663L16.0755 14.8203"
        stroke="#003E4C"
        strokeWidth="1.00341"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0966 19.8521L21.0819 16.8667"
        stroke="#003E4C"
        strokeWidth="1.00341"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0966 16.7036L20.0976 14.7026"
        stroke="#003E4C"
        strokeWidth="1.00341"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Relationship
